import React from 'react';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { SolutionIntro } from '../components/SolutionIntro';
import { Volumes } from '../components/Volumes';
import { InsidePreview } from '../components/InsidePreview';
import { Bonuses } from '../components/Bonuses';
import { Benefits } from '../components/Benefits';
import { SpecialOffer } from '../components/SpecialOffer';
import { Guarantee } from '../components/Guarantee';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { LastChance } from '../components/LastChance';
import { Footer } from '../components/Footer';
import { SalesNotification } from '../components/SalesNotification';
export function Home() {
  return <main className="min-h-screen bg-navy-950 text-white font-inter selection:bg-gold-500/30 selection:text-gold-200" data-id="element-273">
      <SalesNotification data-id="element-274" />
      <Hero data-id="element-275" />
      <PainPoints data-id="element-276" />
      <SolutionIntro data-id="element-277" />
      <Volumes data-id="element-278" />
      <InsidePreview data-id="element-279" />
      <Bonuses data-id="element-280" />
      <Benefits data-id="element-281" />
      <SpecialOffer data-id="element-282" />
      <Guarantee data-id="element-283" />
      <Testimonials data-id="element-284" />
      <FAQ data-id="element-285" />
      <LastChance data-id="element-286" />
      <Footer data-id="element-287" />
    </main>;
}